/**
 * Opt-in flags for always-on ambient surfaces that float over the app.
 *
 * These are quiet by default: they render nothing unless the user has turned
 * them on. They are not popups/alerts/notifications, just ambient status UI, so
 * there is no toast or prompt — a user who wants them sets the flag below.
 *
 *   Regime floating badge:   localStorage['mmec-regime-badge-enabled'] = '1'
 *   Stable-fetch load banner: localStorage['mmec-fetch-progress-banner-enabled'] = '1'
 */

const REGIME_BADGE_KEY = 'mmec-regime-badge-enabled';
const FETCH_PROGRESS_BANNER_KEY = 'mmec-fetch-progress-banner-enabled';

function isOn(key: string): boolean {
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

/** The floating market-regime badge is hidden unless explicitly enabled. */
export function isRegimeBadgeEnabled(): boolean {
  return isOn(REGIME_BADGE_KEY);
}

/** The bottom "loading remaining data" banner is hidden unless explicitly enabled. */
export function isFetchProgressBannerEnabled(): boolean {
  return isOn(FETCH_PROGRESS_BANNER_KEY);
}
